import accountIdReducer from './accountIdReducer';
import locationsReducer from './locationsReducer';

const rootReducer = {
	accountIdReducer,
	locationsReducer
};

export default rootReducer;
